<template>
  <div class="layout-common">
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="16">
        <div class="title">NHNE China 2022</div>
        </Col>
        <Col span="8" class="f-tar">
        <Button shape="circle" @click="$router.push(`/ex-register/register`)">中文</Button>
        <Button shape="circle" style="margin-left:10px;border-color:#d00300;color:#d00300;">English</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">Submit space application</Button>
      </div>

      <div class="tip-info">
        <p>Remarks：</p>
        <p>Please kindly note that this is an application form not a contract. There is a chance that you may not be
          allotted the size of stand which you desire.</p>
      </div>
    </div>
  </div>
</template>
’
<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerAddr from "./components/register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data () {
    return {
      loading: false,
      arr: [{ id: 1, path: 'https://api.chinadentalshow.com:8000/upload/images/202208/1e7dbd8bf75247fcba874d82301c8544.png' }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form },
        lists: [{
          exhibitionId: '57D57E6B-E417-4B44-90F7-A855C96886AD',
          ...res2.ApplyCompanyOrder
        }],
        reportType: 'en'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.nameEn;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyNameEn) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register-en/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "error,try again";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
  },
  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$router.push(`/ex-register-en/register-mobile`);
    }
    document.title = "NHNE booth application";
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.layout-common {
  
  margin: 0 auto;
}
.register {
  max-width: 1200px;
  margin: 0 auto;

  .top {
    padding: 29px 0 40px;
  }

  .title {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
}

.submit-btn {
  margin-top: 50px;
  text-align: center;

  button {
    padding: 0 46px;
    height: 48px;
    background-color: #d00300;
    font-size: 16px;
    border-color: #d00300;
    margin-bottom: 80px;
  }
}

.tip-info {
  width: 1200px;
  margin: 50px auto;

  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
  }
}
</style>
